import { render, staticRenderFns } from "./FcBtnBackBegin.vue?vue&type=template&id=51755ec2&scoped=true&"
import script from "./FcBtnBackBegin.vue?vue&type=script&lang=js&"
export * from "./FcBtnBackBegin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51755ec2",
  null
  
)

export default component.exports